"use client";

import React, { useEffect, useState, useCallback } from "react";
import { Carousel, CarouselContent, CarouselItem, type CarouselApi } from "@/components/ui/carousel";
import { AspectRatio } from "@/components/ui/aspect-ratio";
import { Button } from "@/components/ui/button";
const carouselImages = [{
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1679911/img/Captura de pantalla 2026-05-21 a la(s) 3.32.09 p.m..png",
  alt: "Industrial facility overview"
}, {
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1679911/img/Captura de pantalla 2026-05-21 a la(s) 3.32.23 p.m..png",
  alt: "Heavy machinery in operation"
}, {
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1679911/img/Captura de pantalla 2026-05-21 a la(s) 3.32.21 p.m..png",
  alt: "Precision manufacturing process"
}, {
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1679911/img/Captura de pantalla 2026-05-21 a la(s) 3.32.18 p.m..png",
  alt: "Industrial warehouse interior"
}, {
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1679911/img/Captura de pantalla 2026-05-21 a la(s) 3.32.15 p.m..png",
  alt: "Advanced industrial equipment"
}];
export default function AnimatedHeroCarousel() {
  const [api, setApi] = useState<CarouselApi>();
  const [current, setCurrent] = useState(0);
  const [count, setCount] = useState(0);
  useEffect(() => {
    if (!api) return;
    setCount(api.scrollSnapList().length);
    setCurrent(api.selectedScrollSnap());
    api.on("select", () => {
      setCurrent(api.selectedScrollSnap());
    });
  }, [api]);
  useEffect(() => {
    if (!api) return;
    const intervalId = setInterval(() => {
      api.scrollNext();
    }, 4500);
    return () => clearInterval(intervalId);
  }, [api]);
  const scrollTo = useCallback((index: number) => {
    api?.scrollTo(index);
  }, [api]);
  return <section id="animatedherocarousel" className="w-full bg-background relative overflow-hidden">
      <Carousel setApi={setApi} opts={{
      align: "start",
      loop: true
    }} className="w-full h-full">
        <CarouselContent className="ml-0">
          {carouselImages.map((image, index) => <CarouselItem key={index} data-index={index} className="pl-0 basis-full">
              <AspectRatio ratio={16 / 9} className="w-full">
                <div className="relative w-full h-full overflow-hidden">
                  <img src={image.src} data-wvc-srcset={`${image.src}-wvc-srcset`} data-wvc-sizes={`${image.src}-wvc-sizes`} alt={image.alt} className="object-contain w-full h-full" loading={index === 0 ? "eager" : "lazy"} />
                  
                  
                  <div className="absolute inset-0 bg-gradient-to-t from-black/40 via-transparent to-transparent pointer-events-none" />
                </div>
              </AspectRatio>
            </CarouselItem>)}
        </CarouselContent>
      </Carousel>
    </section>;
}